<template>
  <v-card :loading="loading">
    <v-card-text class="pa-2 caption black--text">
      <apexchart type="heatmap" :height="height" :options="chartOptions" :series="series" />
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  props: {
    title: {
      type: String,
      required: true
    },
    series: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      chartOptions: {
        chart: {
          type: 'heatmap',
          animations: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: this.generateColorsByLength(this.series.length),
        title: {
          text: this.title
        },
        plotOptions: {
          heatmap: {
            distributed: true
          }
        }
      }
    }
  },
  computed: {
    height () {
      return 150 + this.series.length * 20
    }
  }
}
</script>
